import { SYS_COLOR_CANVAS_200_DARK } from '@oneaudi/unified-web-alpha-common';
import type { UnifiedThemeType } from '@oneaudi/unified-web-common';

type GetDesignLibraryProps = {
  unifiedWebCommonVersion?: string;
  unifiedWebAlphaCommonVersion?: string;
};

export const getDesignLibrary = (props?: GetDesignLibraryProps): { [key: string]: string } => {
  if (process.env.IS_LEGACY) {
    return { '@oneaudi/unified-web-common': props?.unifiedWebCommonVersion || '*' };
  } else return { '@oneaudi/unified-web-alpha-common': props?.unifiedWebAlphaCommonVersion || '*' };
};

export const getThemeName = (
  defaultThemeName?: UnifiedThemeType['name'],
): UnifiedThemeType['name'] => {
  if (process.env.IS_LEGACY) {
    return defaultThemeName || 'light';
  } else return 'dark';
};

export const getBackgroundColor = (themeColor: UnifiedThemeType['name'] = 'light'): string => {
  if (process.env.IS_LEGACY) {
    return themeColor === 'light' ? 'white' : 'black';
  } else {
    return SYS_COLOR_CANVAS_200_DARK;
  }
};
